import '../../Styles/index.css';
import { useCallback, useEffect, useState } from 'react';
import izenuAPI from '../../services/izenuAPI';
import { Formik } from 'formik';

const COUNTRIES = [
    { code: 'AO', name: 'Angola' },
    { code: 'BR', name: 'Brasil' },
    { code: 'PT', name: 'Portugal' },
    { code: 'MZ', name: 'Moçambique' },
    { code: 'CV', name: 'Cabo Verde' },
    { code: 'GW', name: 'Guiné-Bissau' },
    { code: 'ST', name: 'São Tomé e Príncipe' },
    { code: 'TL', name: 'Timor-Leste' },
    { code: 'US', name: 'Estados Unidos' },
    { code: 'GB', name: 'Reino Unido' },
    { code: 'FR', name: 'França' },
    { code: 'DE', name: 'Alemanha' },
    { code: 'ES', name: 'Espanha' },
    { code: 'ZA', name: 'África do Sul' },
    { code: 'CD', name: 'RD Congo' },
    { code: 'CG', name: 'Congo' },
    { code: 'NA', name: 'Namíbia' },
    { code: 'ZM', name: 'Zâmbia' },
];

export default function Distributors() {
    const [data, setData] = useState([]);
    const [checked, setChecked] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [editData, setEditData] = useState({});

    const fetchDistributors = useCallback(async () => {
        try {
            const { data: res } = await izenuAPI.get('/admin/distributor/fetch.php');
            if (res.response) {
                setData(res.distributors);
            }
        } catch (error) {
            console.log(error);
        }
    });

    useEffect(() => {
        fetchDistributors();
    }, []);

    const insertDistributor = useCallback(async (data, reset) => {
        try {
            const { data: res } = await izenuAPI.post('/admin/distributor/insert.php', data);
            if (res.response) {
                alert("Distribuidor adicionado com sucesso!");
                reset({ values: '' });
                fetchDistributors();
            } else {
                alert(res.message || "Erro ao adicionar, tenta mais tarde");
            }
        } catch (error) {
            console.log(error);
        }
    });

    const deleteDistributor = useCallback(async (dist) => {
        if (!window.confirm(`Tem certeza que deseja remover "${dist.name}"?`)) return;
        try {
            const { data: res } = await izenuAPI.get(`/admin/distributor/delete.php?distributor_id=${dist.distributor_id}`);
            if (res.response) {
                fetchDistributors();
            } else {
                alert("Erro ao remover distribuidor");
            }
        } catch (error) {
            alert("Erro ao remover distribuidor");
        }
    });

    const startEdit = useCallback((dist) => {
        setEditingId(dist.distributor_id);
        setEditData({
            name: dist.name || '',
            nif: dist.nif || '',
            phone: dist.phone || '',
            email: dist.email || '',
            address: dist.address || '',
            iban: dist.iban || '',
            country_code: dist.country_code || 'AO',
            password: '',
        });
    });

    const cancelEdit = useCallback(() => {
        setEditingId(null);
        setEditData({});
    });

    const saveEdit = useCallback(async () => {
        try {
            const payload = { distributor_id: editingId };
            if (editData.name) payload.name = editData.name;
            if (editData.nif !== undefined) payload.nif = editData.nif;
            if (editData.phone) payload.phone = editData.phone;
            if (editData.email) payload.email = editData.email;
            if (editData.address) payload.address = editData.address;
            if (editData.iban !== undefined) payload.iban = editData.iban;
            if (editData.country_code) payload.country_code = editData.country_code;
            if (editData.password) payload.password = editData.password;

            const { data: res } = await izenuAPI.post("/admin/distributor/updateDistributorData.php", payload);
            if (res.response) {
                setEditingId(null);
                setEditData({});
                fetchDistributors();
            } else {
                alert(res.message || "Erro ao atualizar");
            }
        } catch (error) {
            alert("Erro ao atualizar distribuidor");
        }
    });

    const impersonateDistributor = useCallback(async (dist) => {
        if (!window.confirm(`Entrar no painel de "${dist.name}"?`)) return;
        try {
            const { data: res } = await izenuAPI.post('/admin/impersonate/startImpersonation.php', {
                distributor_id: dist.distributor_id
            });
            if (!res.response) {
                alert(res.message || 'Erro ao impersonar distribuidor');
                return;
            }
            // Backup admin session
            localStorage.setItem('admin_backup_token', localStorage.getItem('token'));
            localStorage.setItem('admin_backup_type', localStorage.getItem('type'));
            localStorage.setItem('admin_backup_id', localStorage.getItem('id'));
            localStorage.setItem('admin_backup_name', localStorage.getItem('name'));
            localStorage.setItem('admin_backup_user', localStorage.getItem('user'));
            // Switch to distributor session
            localStorage.setItem('token', res.token);
            localStorage.setItem('type', 'distributor');
            localStorage.setItem('id', res.distributor.distributor_id);
            localStorage.setItem('name', res.distributor.name);
            localStorage.setItem('user', JSON.stringify(res.distributor));
            localStorage.setItem('impersonating', 'true');
            localStorage.setItem('impersonating_name', res.distributor.name);
            // Reload to switch router
            window.location.href = '/';
        } catch (error) {
            console.log(error);
            alert('Erro ao impersonar distribuidor');
        }
    });

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        return d.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const renderDistributors = useCallback(() => {
        if (data.length > 0) {
            return (<>{data.map((e) => {
                const isEditing = editingId === e.distributor_id;

                if (isEditing) {
                    return (
                        <div key={e.distributor_id} className="border p-3 sm:p-4 mb-3 rounded-lg bg-gray-50">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Nome</label>
                                    <input type="text" value={editData.name} onChange={(ev) => setEditData({...editData, name: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">NIF</label>
                                    <input type="text" value={editData.nif} onChange={(ev) => setEditData({...editData, nif: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" placeholder="Número de identificação fiscal" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Contacto</label>
                                    <input type="text" value={editData.phone} onChange={(ev) => setEditData({...editData, phone: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Email</label>
                                    <input type="email" value={editData.email} onChange={(ev) => setEditData({...editData, email: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Endereço</label>
                                    <input type="text" value={editData.address} onChange={(ev) => setEditData({...editData, address: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">IBAN</label>
                                    <input type="text" value={editData.iban} onChange={(ev) => setEditData({...editData, iban: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">País</label>
                                    <select value={editData.country_code} onChange={(ev) => setEditData({...editData, country_code: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2">
                                        {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.name} ({c.code})</option>)}
                                    </select>
                                </div>
                                <div className="sm:col-span-2">
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Nova palavra-passe (deixar vazio para manter)</label>
                                    <input type="password" value={editData.password} onChange={(ev) => setEditData({...editData, password: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" placeholder="••••••" />
                                </div>
                                <div className="sm:col-span-2 flex gap-2">
                                    <button onClick={saveEdit} className="text-sm px-4 py-2 font-medium bg-amber-500 text-white rounded-lg hover:bg-amber-600">
                                        Guardar
                                    </button>
                                    <button onClick={cancelEdit} className="text-sm px-4 py-2 font-medium bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }

                return (
                    <div key={e.distributor_id} className="border p-3 flex flex-wrap sm:flex-nowrap gap-3 sm:gap-4 mb-3 items-start sm:items-center rounded-lg">
                        <div className="rounded-full bg-gray-300 h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0 flex items-center justify-center">
                            <svg className="text-gray-500 h-10 w-10 sm:h-12 sm:w-12" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                            </svg>
                        </div>
                        <div className="flex-1 min-w-0 break-words">
                            <h3 className="p-0 m-0 text-left font-semibold text-gray-900">{e.name}</h3>
                            <p className="p-0 m-0 text-left text-sm text-gray-600 break-all">{e.email}</p>
                            <p className="p-0 m-0 text-left text-sm text-gray-500">
                                {e.phone}
                                {e.nif ? ` · NIF: ${e.nif}` : ''}
                                {e.country_code ? ` · ${e.country_code}` : ''}
                            </p>
                            {e.address && <p className="p-0 m-0 text-left text-xs text-gray-400">{e.address}</p>}
                            <p className="p-0 m-0 text-left text-xs text-gray-400 break-all">
                                {e.iban ? `IBAN: ${e.iban} · ` : ''}<span className="whitespace-nowrap">{formatDate(e.created_at)}</span>
                            </p>
                        </div>
                        <div className="flex gap-1 sm:gap-2 flex-shrink-0 w-full sm:w-auto justify-end border-t sm:border-t-0 pt-2 sm:pt-0">
                            <button onClick={() => impersonateDistributor(e)} className="p-2 text-gray-500 hover:text-indigo-500 rounded-lg hover:bg-gray-100" title="Ver como distribuidor">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                            </button>
                            <button onClick={() => startEdit(e)} className="p-2 text-gray-500 hover:text-amber-500 rounded-lg hover:bg-gray-100" title="Editar">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button>
                            <button onClick={() => deleteDistributor(e)} className="p-2 text-gray-500 hover:text-red-500 rounded-lg hover:bg-gray-100" title="Remover">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                );
            })}</>);
        } else {
            return (<div className="justify-center items-center h-full flex">
                <h1 className="text-grey-500 font-light text-xl">Nenhum distribuidor encontrado</h1>
            </div>);
        }
    }, [data, editingId, editData]);

    return (<div className="max-w-6xl mx-auto text-left">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Distribuidores ({data.length})</h1>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 sm:gap-6 items-start">
            <section className="lg:col-span-3 border rounded-xl p-3 sm:p-5 bg-white">
                {renderDistributors()}
            </section>
            <section className="lg:col-span-2 border rounded-xl p-3 sm:p-5 bg-white">
                <h2 className="font-semibold text-gray-900 mb-3 text-left">Adicionar distribuidor</h2>
                <Formik
                    initialValues={{ email: '', pwd: '', nif: '', phone: '', address: '', iban: '', name: '', country_code: 'AO' }}

                    validate={values => {
                        const errors = {};
                        if (!values.email) {
                            errors.email = 'Campo obrigatório!';
                        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                            errors.email = 'Endereço de email inválido!';
                        }
                        if (values.name === '') {
                            errors.name = 'Campo obrigatório!';
                        }
                        if (values.phone === '') {
                            errors.phone = 'Campo obrigatório!';
                        }
                        if (values.address === '') {
                            errors.address = 'Campo obrigatório!';
                        }
                        if (values.pwd === '') {
                            errors.pwd = 'Campo obrigatório!';
                        }
                        return errors;
                    }}

                    onSubmit={(values, { setSubmitting, resetForm }) => {
                        setTimeout(() => {
                            insertDistributor(values, resetForm);
                            setSubmitting(false);
                        }, 400);
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Nome</label>
                            {errors.name && touched.name && <span className="text-red-500 text-xs">{errors.name}</span>}
                            <div className="relative mb-4">
                                <input type="text" name="name" onChange={handleChange} onBlur={handleBlur} value={values.name}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5" placeholder="Nome da distribuidora" />
                            </div>

                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">NIF</label>
                            <div className="relative mb-4">
                                <input type="text" name="nif" onChange={handleChange} onBlur={handleBlur} value={values.nif}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5" placeholder="Número de identificação fiscal (opcional)" />
                            </div>

                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Contacto</label>
                            {errors.phone && touched.phone && <span className="text-red-500 text-xs">{errors.phone}</span>}
                            <div className="relative mb-4">
                                <input type="text" name="phone" onChange={handleChange} onBlur={handleBlur} value={values.phone}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5" placeholder="+244 9XX XXX XXX" />
                            </div>

                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Email</label>
                            {errors.email && touched.email && <span className="text-red-500 text-xs">{errors.email}</span>}
                            <div className="relative mb-4">
                                <input type="email" name="email" onChange={handleChange} onBlur={handleBlur} value={values.email}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5" placeholder="Email da distribuidora" />
                            </div>

                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">IBAN</label>
                            <div className="relative mb-4">
                                <input type="text" name="iban" onChange={handleChange} onBlur={handleBlur} value={values.iban}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5" placeholder="IBAN da distribuidora (opcional)" />
                            </div>

                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Endereço</label>
                            {errors.address && touched.address && <span className="text-red-500 text-xs">{errors.address}</span>}
                            <div className="relative mb-4">
                                <input type="text" name="address" onChange={handleChange} onBlur={handleBlur} value={values.address}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5" placeholder="Endereço da distribuidora" />
                            </div>

                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">País</label>
                            <div className="relative mb-4">
                                <select name="country_code" onChange={handleChange} onBlur={handleBlur} value={values.country_code}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5">
                                    {COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.name} ({c.code})</option>)}
                                </select>
                            </div>

                            <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Palavra-passe</label>
                            {errors.pwd && touched.pwd && <span className="text-red-500 text-xs">{errors.pwd}</span>}
                            <div className="relative mb-4">
                                <input type="password" name="pwd" onChange={handleChange} onBlur={handleBlur} value={values.pwd}
                                    className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5" placeholder="Palavra-passe" />
                            </div>

                            <div className="relative mb-4">
                                <div className="flex items-center">
                                    <input onClick={() => setChecked(!checked)} id="link-checkbox" type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-amber-500" />
                                    <label htmlFor="link-checkbox" className="ms-2 text-sm font-medium text-gray-900">Concordar com os nossos termos de utilização</label>
                                </div>
                            </div>
                            <div className="relative mb-6">
                                <button type={checked ? "submit" : "button"} className="h-full text-sm px-4 py-2 font-medium bg-amber-500 text-white rounded-lg hover:bg-amber-600">
                                    Adicionar distribuidor
                                </button>
                            </div>
                        </form>
                    )}
                </Formik>
            </section>
        </div>
    </div>);
}
